module.exports = __webpack_public_path__ + "static/media/0020.0fe42a24.svg";